// type Phase_D = {
//     step:  string;
//     title: string;
//     text:  string[];
// };

// type Phase_E = {
//     step:        string;
//     title:       string;
//     description: string;
//     text:        string[];
// };

// type Phase_B = {
//     step: string;
//     expectations:
//         {
//             id:      string;
//             heading: string;
//             benchmarks:
//                 {
//                     id:   string;
//                     text: string;
//                     subBenchmarks: 
//                         {
//                             id:              string;
//                             phase:           object;
//                             checklistItems:  string[];
//                             feedback:        string;
//                             type:            string;
//                         }[];
//                 }[];
//         }[];
// };

// type Phase_R = {
//     step:    string;
//     slides:  string[] | { text: { __html: string; linkHoverText: object; }}[];
// };

// type Phase_F = {
//     step:      string;
//     title:     string;
//     heading:   string;
//     questions: string;
// };

// type Step_Data = [Phase_D, Phase_E, Phase_B, Phase_R, Phase_F];

// export const STEP_DATA: Step_Data = [

import {link, para, text} from "./utils";

export const SC8CP_PhaseDEBRF = [
    {
        step: "D",
        title: "Define Rules:",
        text: ["The purpose of this debriefing is to reflect on the scenario you have just completed in order to help you improve your skills as a paramedic.  It is not meant to assess your overall abilities as a paramedic.", "This debriefing will summarize the learning objectives of this scenario and the performance benchmarks (standards) for achieving each objective.  The system will then prompt you to examine differences between the treatment actions that you performed and those indicated by the clinical findings revealed during the scenario, or that would have been revealed by a more thorough assessment and reassessment of this patient.  Finally, it will prompt you to state some 'take home points' to improve your performance."]
    },
    {
        step: "E",
        title: "Explain the learning objectives:",
        description: "This scenario was designed to give you practice with:",
        text: [
            "Conducting a thorough trauma patient assessment",
            "Managing a potential head and/or spinal injury",
            "Managing a compromised airway",
            "Managing inadequate breathing",
            "Making appropriate transport decisions",
            "Performing ongoing patient management and assessment",
        ]
    },
    {
        step: "B",
        expectations: [
            {
                expectationText: "Conduct a thorough trauma assessment",
                benchmarks: [
                    {
                        benchmarkText: "Before approaching patient, apply PPE, check that the scene is safe, determine the number of patients, and request additional help if necessary",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "On initial patient contact, form a general impression of the patient's condition, assess patient's level of consciousness, and identify apparent life threats",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "During the Primary Survey:",
                        subBenchmarks: 
                        [
                            "Check that airway is open, clear of fluids and foreign bodies, and has intact physical structures", 
                            "Listen for abnormal breath sounds and check breathing rate, rhythm, and quality", 
                            "Check circulation: pulse rate/rhythm/quality; skin color/temperature/condition; perform gross blood sweep",
                            "Determine the need for rapid transport and call for an air ambulance asap (i.e., before conducting your Secondary Survey)",
                            "Trauma expose patient"
                        ]
                    },
                    {
                        benchmarkText: "Take baseline vitals and, if possible, obtain SAMPLE history and OPQRST",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Perform a rapid head-to-toe assessment (Secondary Survey), looking/listening/feeling for DCAP-BTLS and abnormal conditions at each body part (e.g., check neck for tracheal deviation and JVD).",
                        subBenchmarks: []
                    },
                ]
            },
            {
                expectationText: "Manage a potential head or spinal injury",
                benchmarks: [
                    {
                        benchmarkText: "Identify the potential for head or spinal injury during your initial assessment",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Direct manual stabilization of the cervical spine before checking airway, breathing and circulation",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Apply an appropriately sized cervical collar",
                        subBenchmarks: []
                    },
                ]
            },
            {
                expectationText: "Manage a compromised airway",
                benchmarks: [
                    {
                        benchmarkText: "Open the patient's airway via jaw-thrust instead of head-tilt",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Suction the patient's mouth using a Yankauer or Long multi-use catheter",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Insert an oropharyngeal airway",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Ultimately, intubate the patient.  Pre-oxygenate with a nasal cannula or BVM and then place a size 4.5 or 5.0 ET tube inserted at the correct depth. Alternatively, insert an appropriately sized advanced/rescue airway.",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Confirm placement of the tube by checking ETCO2 capnography, listening for bilateral lung sounds and absence of gastric sounds. Additional checks include visualizing the tube passing through the vocal cords (if an ET tube) and re-evaluating vital signs.",
                        subBenchmarks: []
                    },
                ]
            },
            {
                expectationText: "Manage inadequate breathing",
                benchmarks: [
                    {
                        benchmarkText: "Ventilate the patient at a rate of 20 breaths per minute",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Titrate oxygen at a flow rate of 15 L/min to a target SpO2 > = 90%",
                        subBenchmarks: []
                    },
                ]
            },
            {
                expectationText: "Make appropriate transport decisions",
                benchmarks: [
                    {
                        benchmarkText: "Transport patient to Level 1 pediatric tauma center by air ambulance",
                        subBenchmarks: []
                    },
                ]
            },
            {
                expectationText: "Perform ongoing patient management and assessment",
                benchmarks: [
                    {
                        benchmarkText: "Assist air crew in providing a patient report and ETA to the receiving facility",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Establish at least one IV en route",
                        subBenchmarks: []
                    },
                    {
                        benchmarkText: "Reassess vitals every 5 minutes; repeat primary and secondary survey",
                        subBenchmarks: []
                    },
                ]
            }
        ]
    },
    {
        step: "R",
        slides: [
            {
                paragraphs: [
                    para(
                        text("In an idealized scenario, you arrive on scene and find a 4-year-old boy lying supine beside a pool in the backyard of a suburban house. Other EMS responders have arrived on site to assist you.  Your initial assessment reveals that the boy is unconscious and cyanotic.  A quick pulse check shows that it is slow and weak. Given that the patient is in"),
                        link("critical condition,", "This patient is unresponsive and is therefore considered a critical patient."),
                        text("you direct a responder to call for air transport to the"),
                        link("nearest pediatric trauma center.", "Because this patient is under 14 years of age, he should be transported to the nearest level 1 or 2 pediatric trauma center that is less than 45 minutes away.")
                    ),
                    para(
                        text("You direct another partner to take"),
                        link("manual c-spine precautions", "Any near-drowning or drowning, especially if unwitnessed, should be considered a risk for possible cervical and spinal injury as the patient may have been involved in a diving accident."),
                        text("and apply a cervical collar. You open the patient’s airway, using a jaw thrust maneuver.  Finding a substantial amount of water and vomit in the boy’s mouth, you apply suction. After the patient’s airway is cleared, you assess breathing and find it to be slow with gurgling sounds. You direct your partner to insert an OPA and ventilate the patient with 100% oxygen delivered through a"),
                        link("bag-valve mask", "This patient was not adequately ventilating (slow, gurgling breaths) or oxygenating (low SpO2) so O2 delivered via nasal cannula or non-rebreather mask would not have been adequate.")
                    )
                ]
            }, 
            {
                paragraphs: [
                    para(
                        text("You then"),
                        link("intubate the patient", "The patient was unresponsive with a GCS of 3 so should be intubated to safely get the patient to the pediatric trauma center (remember, generally with a GCS <8, you should intubate)."),
                        text("and direct your partner to resume BVM ventilation all while maintaining c-spine precautions. You have another responder obtain a set of baseline vitals and obtain a SAMPLE and OPQRST history from the babysitter while you perform a rapid head-to-toe assessment.  On completion of your secondary survey, you secure him onto a long back board.")
                    ),
                    para(
                        text("You and your partners then place the patient on a stretcher and transfer him to the helicopter as soon as it arrives.  You cover him with blankets and ask the pilot to turn up the heat. While en route to the pediatric trauma center, you contact the facility to alert them to the patient’s condition and your ETA.  You establish two large bore IVs, reassess the patient"),
                        link("every five minutes,", "Critically ill patients should be reassessed every 5 minutes."),
                        text("and confirm that all interventions are working properly, modifying any as necessary.")
                    )
                ]
            }
        ]
    },
    {
        step: "F",
        title: "Formalize learning",
        heading: "Please take a few minutes to think and reply to these questions",
        questions: "What are your key take-home points from this scenario? What is something you want to continue working on or do differently in the future?"
    }
];